/** The order feature's URL segments, used by routes. */
export const ORDER_SEGMENT = "order";
export const ORDER_LIST_SEGMENT = "list";
export const ORDER_SNAPSHOT_SEGMENT = "snapshot";

/** The order feature's full paths, used by navigation and links. */
export const ORDER_PATH = `/${ORDER_SEGMENT}`;
export const ORDER_LIST_PATH = `${ORDER_PATH}/${ORDER_LIST_SEGMENT}`;
export const ORDER_SNAPSHOT_PATH = `${ORDER_PATH}/${ORDER_SNAPSHOT_SEGMENT}`;
